(() => {
  const keys = new Set(['hunting', 'range', 'outdoor', 'tactical', 'camping', 'training', 'emergency', 'airsoft']);
  const body = document.body;
  const context = document.querySelector('[data-br-product-context]');
  const choices = [...document.querySelectorAll('[data-br-choice]')];
  const worldRoots = new Map([...document.querySelectorAll('[data-br-nav-world]')].map(link => [new URL(link.href).pathname, link.dataset.brNavWorld]));
  const currentUrl = new URL(location.href);
  const requested = currentUrl.searchParams.get('br_world');
  let active = context?.dataset.world || body.dataset.brWorld || '';
  const rootWorld = worldRoots.get(location.pathname);
  if (rootWorld) active = rootWorld;
  else if (keys.has(requested) && (!context || choices.some(a => a.dataset.brChoice === requested))) active = requested;
  if (!keys.has(active)) active = '';
  body.dataset.brWorld = active;
  if (context) {
    context.dataset.world = active;
    const selected = choices.find(a => a.dataset.brChoice === active);
    for (const choice of choices) {
      const isCurrent = choice === selected;
      choice.classList.toggle('is-current', isCurrent);
      if (isCurrent) choice.setAttribute('aria-current', 'true');
      else choice.removeAttribute('aria-current');
      const url = new URL(choice.href);
      for (const key of ['variant', 'preview_theme_id']) if (currentUrl.searchParams.has(key)) url.searchParams.set(key, currentUrl.searchParams.get(key));
      url.searchParams.set('br_world', choice.dataset.brChoice);
      choice.href = url.href;
    }
    if (selected) {
      const home = context.querySelector('[data-br-world-home]');
      home.href = selected.dataset.brWorldHomeUrl;
      home.textContent = selected.dataset.brWorldLabel;
      const back = context.querySelector('[data-br-category-back]');
      if (back) { back.href = selected.dataset.brCategoryUrl; back.textContent = selected.dataset.brCategoryLabel; const duplicate = back.pathname === home.pathname; back.hidden = duplicate; const separator = context.querySelector('[data-br-category-separator]'); if (separator) separator.hidden = duplicate; }
    }
    const advisor = document.querySelector('[data-br-product-advisor]');
    if (advisor) {
      advisor.dataset.world = active;
      advisor.querySelectorAll('[data-br-advice-world]').forEach(panel => { panel.hidden = panel.dataset.brAdviceWorld !== active; });
      const neutral = advisor.querySelector('[data-br-advice-neutral]');
      if (neutral) neutral.hidden = Boolean(selected);
    }
  }
  document.querySelectorAll('[data-br-nav-world]').forEach(link => {
    link.classList.toggle('is-current', link.dataset.brNavWorld === active);
  });
  if (body.dataset.brPage === 'collection' && active) {
    const subcategory = document.querySelector('.br-subcategory');
    if (subcategory) {
      subcategory.dataset.world = active;
      const home = document.querySelector(`[data-br-nav-world="${active}"]`);
      if (home) subcategory.querySelectorAll('.br-subcategory__world, .br-subcategory__breadcrumb a').forEach(link => {
        if (link.pathname !== '/' && link.pathname !== location.pathname) { link.href = home.href; const arrow = link.querySelector('span'); link.textContent = home.textContent.trim(); if (arrow) link.append(arrow); }
      });
    }
  }
  function carryWorld(link) {
    if (!link?.href || link.hasAttribute('data-br-choice')) return;
    let url;
    try { url = new URL(link.href); } catch { return; }
    if (url.origin !== location.origin || !/^\/(collections|products)\//.test(url.pathname) || link.getAttribute('href')?.startsWith('#')) return;
    const direct = worldRoots.get(url.pathname) || link.dataset.brNavWorld || link.dataset.brWorld;
    const scope = link.closest('[data-br-advice-world], [data-world]');
    if (!direct && !scope && !link.closest('main, .br-product-context, .br-product-advisor')) return;
    const world = direct || scope?.dataset.brAdviceWorld || scope?.dataset.world || active;
    if (!keys.has(world)) return;
    if (url.pathname.startsWith('/products/') && body.dataset.brPage === 'collection' && !location.pathname.includes('/products/')) url.pathname = location.pathname + url.pathname;
    url.searchParams.set('br_world', world);
    link.href = url.href;
  }
  document.querySelectorAll('a[href]').forEach(carryWorld);
  document.addEventListener('click', event => carryWorld(event.target.closest('a[href]')), {capture:true});
  const grid = document.querySelector('#product-grid');
  if (grid) new MutationObserver(() => grid.querySelectorAll('a[href]').forEach(carryWorld)).observe(grid, {childList:true, subtree:true});
})();
